<dialog-draggable-header>Parts Reports</dialog-draggable-header>

<p style="text-decoration: underline">Select Report Criteria</p>
<p style = "padding-top: 15px;">Part Change Approval Date Range</p>

<mat-dialog-content style = "padding-top: 10px;"class="flex-dialog-container">
   <form class="flex-dialog-container" [formGroup]="partsReportForm">
      <div class="space-between-items" style="margin-bottom: -8px;">

         <mat-form-field style="width: 50%; padding-right: 1em;">
            <mat-label for="start">Start</mat-label>
            <input matInput [matDatepicker]="start" [formControl]="partsReportForm.controls.startApproval" />
            <mat-datepicker-toggle matSuffix [for]="start"></mat-datepicker-toggle>
            <mat-datepicker #start></mat-datepicker>
         </mat-form-field>

         <mat-form-field style="width: 50%; padding-left: 1em;">
            <mat-label for="end">End</mat-label>
            <input matInput [matDatepicker]="end" formControlName="endApproval" />
            <mat-datepicker-toggle matSuffix [for]="end"></mat-datepicker-toggle>
            <mat-datepicker #end></mat-datepicker>
         </mat-form-field>

         <button (click)="toggleDatesField()" (keypress.enter)="toggleDatesField()" class="button-style"
            mat-raised-button>All </button>
      </div>

      <div class="space-between-items" style="margin-bottom: -8px;">
         <searchable-autocomplete style="width: 100%;" [options]="this.programs" label="Program"
            formControlName="program" [exactMatch]="true" filterBy="programNameYear">
         </searchable-autocomplete>
         <button (click)="toggleProgramField()" (keypress.enter)="toggleProgramField()" class="button-style"
            mat-raised-button>All </button>
      </div>

      <div class="space-between-items" style="margin-bottom: -8px;">
         <searchable-autocomplete style="width: 100%;" [options]="this.authNumbers" label="Authority Number"
            [emptySelection]="true" formControlName="authNumber" [exactMatch]="true" [stringOptions]="true">
         </searchable-autocomplete>
         <button (click)="toggleAuthNumberField()" (keypress.enter)="toggleAuthNumberField()" class="button-style"
            mat-raised-button>All </button>
      </div>

   </form>
</mat-dialog-content>
<div>
   <p style="color: green;">To select a specific Program or Authority Number or to change the Start and End dates, click
      the All button then make selection. To de-select, click the All button again which will disable your selection.
   </p>
</div>

<div mat-dialog-actions class="mat-dialog-actions-end mat-dialog-actions-margin">
   <button mat-raised-button (click)="onPartsListClick()" (keypress.enter)="onPartsListClick()">
      Parts List
   </button>
   <button mat-raised-button (click)="onDetailedPartsListClick()" (keypress.enter)="onDetailedPartsListClick()">
      Detailed Parts List</button>
   <button mat-raised-button (click)="onDetailedPartsListDesignGDTClick()"
      (keypress.enter)="onDetailedPartsListDesignGDTClick()">
      Detailed Parts List - Design/GD&T
   </button>
   <button mat-raised-button (click)="onToolPartListClick()" (keypress.enter)="onToolPartListClick()">
      Tool/Part Relationship List
   </button>
   <button mat-raised-button cdkFocusInitial (click)="onCloseClick()" (keypress.enter)="onCloseClick()">Close</button>
</div>